import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginScreen from "@/components/LoginScreen";
import StudioShell from "@/components/StudioShell";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="app-bg min-h-screen grid place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-[#FF3B60]" />
      </div>
    );
  }
  return user ? <StudioShell /> : <LoginScreen />;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" theme="dark" richColors />
      <Gate />
    </AuthProvider>
  );
}
